module.exports = __webpack_public_path__ + "img/1ggk4Neo-sEGpPObXfZDAlp0w4crRqztx.f9ed7c1e.png";